import React, {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {useHistory} from "react-router-dom";
import {Button} from "primereact/button";

const CrmActionbuttonsComponent = (props) => {

  const history = useHistory();

  useEffect(() => {
  }, [])

  return (
    <span className={"action-buttons"}>
      <Button icon="pi pi-bolt"
              iconPos="right"
              onClick={() => {
                history.push('/crm/lead/create')
              }}
              className={"p-button-link"}
              label={props.t('addLead')}
      />
      <Button icon="pi pi-bolt"
              iconPos="right"
              onClick={() => {
                history.push('/crm/task/create')
              }}
              className={"p-button-link"}
              label={props.t('addTask')}
      />
      <Button icon="pi pi-bolt"
              iconPos="right"
              onClick={() => {
                history.push('/crm/action/create')
              }}
              className={"p-button-link"}
              label={props.t('addActivity')}
      />
    </span>
  )
}
export default withTranslation('common')(CrmActionbuttonsComponent);
